import type { Cell } from "@/logic/GridBuilder"
import { Gap } from "@kaleidoscope-solutions/engine-wasm"

function addClass(cssClasses: string[], cssClass: string) {
  if (!cssClasses.includes(cssClass)) {
    cssClasses.push(cssClass)
  }
}

export function setCellClassByCell({ hierarchyLevel, nextRowNested, firstRow, lastRow, firstCellInRow, lastCellInRow, adjacentCellGaps }: Pick<Cell, "hierarchyLevel" | "nextRowNested" | "firstRow" | "lastRow" | "firstCellInRow" | "lastCellInRow" | "adjacentCellGaps">) {
  const cssClasses: string[] = []

  const afterRowGap = adjacentCellGaps.includes(Gap.Top)
  const beforeRowGap = adjacentCellGaps.includes(Gap.Bottom)
  const afterColGap = adjacentCellGaps.includes(Gap.Left)
  const beforeColGap = adjacentCellGaps.includes(Gap.Right)

  if (firstCellInRow && hierarchyLevel > 0) {
    addClass(cssClasses, `cell--indent-${hierarchyLevel}`)
  }

  if (firstRow) {
    addClass(cssClasses, "first-row")
  }

  if (lastRow) {
    addClass(cssClasses, "last-row")
  }

  if (firstCellInRow) {
    addClass(cssClasses, "first-cell")
  }

  if (lastCellInRow) {
    addClass(cssClasses, "last-cell")
  }

  if (beforeColGap) {
    addClass(cssClasses, "cell-before-col-gap")
  }

  if (beforeRowGap) {
    addClass(cssClasses, "cell-before-row-gap")
  }

  if (afterColGap) {
    addClass(cssClasses, "cell-after-col-gap")
  }

  if (afterRowGap) {
    addClass(cssClasses, "cell-after-row-gap")
  }

  // Top Left
  if (afterRowGap && afterColGap) {
    addClass(cssClasses, "cell-tl")
  }

  if ((firstRow || afterRowGap) && firstCellInRow) {
    addClass(cssClasses, "cell-tl")
  }

  if (afterColGap && afterRowGap) {
    addClass(cssClasses, "cell-tl")
  }

  if (firstRow && afterColGap) {
    addClass(cssClasses, "cell-tl")
  }

  // Top Right

  if (firstRow && beforeColGap) {
    addClass(cssClasses, "cell-tr")
  }

  if (afterRowGap && afterColGap && lastCellInRow) {
    addClass(cssClasses, "cell-tr")
  }

  if (afterRowGap && lastCellInRow) {
    addClass(cssClasses, "cell-tr")
  }

  if (beforeColGap && afterRowGap) {
    addClass(cssClasses, "cell-tr")
  }

  if (firstRow && lastCellInRow) {
    addClass(cssClasses, "cell-tr")
  }

  // Bottom Right
  if (lastRow && lastCellInRow) {
    addClass(cssClasses, "cell-br")
  }

  if (lastCellInRow && beforeRowGap) {
    addClass(cssClasses, "cell-br")
  }

  if (lastRow && beforeColGap) {
    addClass(cssClasses, "cell-br")
  }

  if (beforeColGap && beforeRowGap) {
    addClass(cssClasses, "cell-br")
  }

  // Bottom Left
  if (firstCellInRow && lastRow) {
    addClass(cssClasses, "cell-bl")
  }

  if (afterColGap && beforeRowGap) {
    addClass(cssClasses, "cell-bl")
  }

  if (afterColGap && lastRow) {
    addClass(cssClasses, "cell-bl")
  }

  if (firstCellInRow && beforeRowGap) {
    addClass(cssClasses, "cell-bl")
  }

  if (firstCellInRow && nextRowNested) {
    addClass(cssClasses, "cell-bl")
  }

  return cssClasses
}
